import styled from 'styled-components/macro'

export const AuthorSC = styled.div`
  align-self: flex-start;
  margin-top: 10px;
`
